import React, { forwardRef } from 'react';
import { Alert, Snackbar } from '@mui/material';

const SnackbarALert = forwardRef(function SnackbarALert(props, ref) {
  return <Alert elevation={6} ref={ref} {...props} />;
});
const Toast = ({ open, setOpen, message, severity, isLocked }) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={isLocked ? 300000 : 5000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <SnackbarALert onClose={handleClose} severity={severity}>
          {message}
        </SnackbarALert>
      </Snackbar>
    </>
  );
};

export default Toast;
